/**
 * Created by fwt on 2019/4/1.
 */
import React,{Component} from "react"
import {NavBar,Steps,Toast} from 'antd-mobile';
import {getRefundInfo} from "../../../../service/orderService";
import {connect} from "react-redux";
import moment from 'moment';
import './style.less';
const Step = Steps.Step;
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class Refund extends Component{
    constructor(props) {
        super(props);
        this.state={
            data:{},
            applyTime:"",
            orderNum:"",
            money:"",
            deduction:"",
            subPrice:"",
            realityMoney:"",
            step:"",
            payType:"",
            createTime:"",
            uptime:""
        }
    }

    componentDidMount() {
       this.getRefundDetail();
    }
    getRefundDetail(){
        let params = {
            token:this.props.userInfo.token,
            source:1,
            data:{id:this.props.location.state.orderId,tailoredType:this.props.location.state.tailoredType},
        };
        Toast.loading("正在加载");
        getRefundInfo(params).then(res=>{
            Toast.hide();
            const data = res.data.data;
            this.setState({
                applyTime:moment(data.createTime).format("YYYY-MM-DD HH:mm:ss"),
                orderNum:data.oldOrderNo,
                money:data.seatPrice,
                deduction:data.score,
                subPrice:data.subPrice,
                realityMoney:data.realityPrice,
                payType:data.type,
                step:data.isFinish,
                createTime:moment(data.createTime).format("YYYY-MM-DD HH:mm:ss"),
                uptime:moment(data.uptime).format("YYYY-MM-DD HH:mm:ss")
            });

            if(res.data.code == "0000"){
                this.setState({data:res.data.data})
            }else{
                Toast.info(res.data.msg)
            }
        }).catch(function (error) {
            console.log(error);
        });
    };

    render() {
        const {data}=this.state;
        return (
            <div className="refund">
                <NavBar
                        className="navBar"
                        mode="light"
                        icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                    >
                    退款详情
                </NavBar>
                {/* 头部内容    */}
               <div className="wrap">

                   <div className="contentTop">
                       <div className="contentbox">
                           <div className="header">退款信息</div>
                           <div className="box">
                               <div className="title">申请时间</div>
                               <div className="content">{data.applyTime}</div>
                           </div>
                           <div className="box">
                               <div className="title">原始单号</div>
                               <div className="content">{data.orderNum}</div>
                           </div>
                       </div>
                       <div className="contentbox">
                           <div className="box">
                               <div className="title">票价金额</div>
                               <div className="content">¥{data.seatPrice}</div>
                           </div>
                           <div className="box">
                               <div className="title">抵扣金额</div>
                               <div className="content">-¥{data.preferentialPrice}</div>
                           </div>
                           <div className="box">
                               <div className="title">退款费用</div>
                               <div className="content">-¥{data.serviceCharge}</div>
                           </div>
                       </div>
                       <div className="contentbox">
                           <div className="box">
                               <div className="title">实际退款</div>
                               <div className="content"><span className="money">¥{data.refundAmount}</span></div>
                           </div>
                           <div className="box">
                               <div className="title">退款方式</div>
                               <div className="content"><span className="refundWay">{data.refundWay == 'wx' ? <div>微信支付</div>:<div>工行支付</div> }</span></div>
                           </div>
                       </div>
                   </div>

                   <div className="steps">
                       <div className="footer">退款进度</div>
                       <Steps current={data.refundStatus == 1 ? 1: 3}>
                           <Step
                               title={(<div className="apply"><div className="commit">申请已提交</div><div className="date">{data.applyTime}</div></div>)}
                               description="您的退款申请已提交，请耐心等待工作人员审核"/>
                           <Step
                               title="申请审核中"
                               description="您的退款申请正在由工作人员审核，需要2-3工作日！" />
                           <Step
                               status={data.refundStatus == 3 ? "error" : "finish"}
                               title={(
                                   <div  className="apply">
                                    <div className="commit">{data.refundStatus == 3 ? "退款失败": "退款成功"}</div>
                                   </div>)}
                               description={data.refundStatus == 3 ? "请联系客服！":"您的退款已由工作人员转入你的微信账户，请查看！"} />
                       </Steps>
                   </div>

               </div>

            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/MyOrder/refund/index.js